import { render, staticRenderFns } from "./WidgetPublicViewPayment.vue?vue&type=template&id=6f2f3054&scoped=true"
import script from "./WidgetPublicViewPayment.vue?vue&type=script&lang=js"
export * from "./WidgetPublicViewPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f3054",
  null
  
)

export default component.exports